import React from 'react';

import {
    CheckCircle as PagoIcon,
    Error as EmAtrasoIcon,
    WatchLater as EmAbertoIcon
} from '@material-ui/icons';

import { StatusFaturamentoEnum } from '../enums';

function IconeStatusFaturamento(
    {
        codigoStatus,
        ...props
    }
) {
    const icone = {
        [StatusFaturamentoEnum.PAGO]: <PagoIcon {...props} />,
        [StatusFaturamentoEnum.EM_ATRASO]: <EmAtrasoIcon {...props} />,
        [StatusFaturamentoEnum.EM_ABERTO]: <EmAbertoIcon {...props} />
    }

    return (icone[codigoStatus]);
}

export default IconeStatusFaturamento;